import { FormDialog } from '@aibees/shared/components';
import { Box, Link } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)``;

export const Dialog = styled(FormDialog)``;

export const GoogleSetting = styled(Link)`
  text-decoration: none;
  color: ${(p) => p.theme.palette.primary[500]};
  font-weight: ${(p) => p.theme.typography.fontWeightBold};
`;
